import formatByCountry from "./FormatByCountry";
import { MY_CURRENCY_DISPLAY_PREFIX, configPrice } from "./modules/Price";

const formatPrice = (
  price: number,
  prefixPositive = "",
  currency: "IDR" | "MYR" = "IDR"
): string => {
  const country = currency === "MYR" ? "MY" : "ID";
  const prefix =
    currency === "MYR"
      ? MY_CURRENCY_DISPLAY_PREFIX
      : configPrice.IDR?.prefix ?? "Rp";

  const sign = price < 0 ? "- " : prefixPositive;
  const formatted = formatByCountry(Math.abs(price), {
    type: "money",
    country
  });
  return `${sign}${prefix}${formatted}`;
};
export default formatPrice;
